/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_Link_InvalidInputs */



/**
* | output |
* | --- |
* | "That sign-in link is no longer valid. Request a new one." |
*
* @param {Canvas_Sign_In_Link_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_link_invalid = /** @type {((inputs?: Canvas_Sign_In_Link_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_Link_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Anmeldelink ist nicht mehr gültig. Fordern Sie einen neuen an.")
	return /** @type {LocalizedString} */ ("That sign-in link is no longer valid. Request a new one.")
});